import { clsx } from 'clsx';
import { Icon } from '../../../../icon/Icon';
import { GenericStatusLabel } from '../../../../shared/components/GenericStatusLabel/GenericStatusLabel';
import { NodeLogo } from '../../../../shared/components/NodeLogo/NodeLogo';
import { Tooltip } from '../../../../tooltip/Tooltip';
import { PipelineActions } from '../../../PipelineActions/PipelineActions';
import { PipelineSyncFrequencyDisplay } from '../../../PipelineSyncFrequency/PipelineSyncFrequencyDisplay';
import { usePipeline } from '../../context/usePipeline';

export function PipelineHeader() {
  const { pipeline, updatePipeline } = usePipeline();

  const pipelineName = pipeline!.name;
  const destinationName = pipeline!.destination!.name;
  const { sourceType, name: sourceName } = pipeline!.source!;
  const { destinationType } = pipeline!.destination!;

  return (
    <header className='secondary-nav floating-header center-flex-row py-4 px-5'>
      <div className='integration-heading flex-1'>
        <span className='entity-id-container text-nowrap'>
          <span className='entity-id'>#{pipeline!.seqId}</span>
        </span>

        <div className='overflow-hidden'>
          <Tooltip dataId='pipeline-name' title={pipelineName} enableOnTextOverflow>
            <div className='text-subheading-2 text-ellipsis'>{pipelineName}</div>
          </Tooltip>

          <div className='center-flex-row mt-1'>
            <Tooltip dataId='source-type' title={sourceType.displayName}>
              <span>
                <NodeLogo
                  logoURL={sourceType.logo}
                  darkModeLogoURL={sourceType.logoDarkMode}
                  withContextualBg
                  size={13}
                  roundedBorders
                />
              </span>
            </Tooltip>

            <Tooltip dataId='source-name' title={sourceName} enableOnTextOverflow>
              <div className='text-ellipsis text-secondary ml-1'>{sourceName}</div>
            </Tooltip>

            <Icon
              className={clsx('mx-2', `text-${pipeline!.status.colorType}`)}
              name='pipeline-connection'
            />

            <Tooltip dataId='destination-type' title={destinationType.displayName}>
              <span>
                <NodeLogo
                  logoURL={destinationType.logo}
                  darkModeLogoURL={destinationType.logoDarkMode}
                  withContextualBg
                  size={13}
                  roundedBorders
                />
              </span>
            </Tooltip>

            <Tooltip dataId='destination-name' title={destinationName} enableOnTextOverflow>
              <div className='text-ellipsis text-secondary ml-1'>{destinationName}</div>
            </Tooltip>
          </div>
        </div>
      </div>

      <div className='center-flex-row'>
        <div className='flex-col align-items-end mr-5'>
          <GenericStatusLabel status={pipeline!.status} withIcon={!!pipeline!.status.icon} />

          <PipelineSyncFrequencyDisplay pipeline={pipeline!} withLabel className='mt-1' />
        </div>

        <PipelineActions pipeline={pipeline!} updatePipeline={updatePipeline} />
      </div>
    </header>
  );
}
